/**
 * @file assetLibraryService.js
 * @description Orchestrates asset library create/update flows (file upload plus
 * asset persistence) as single background-safe units, independent of the
 * component that started them.
 */
import { uploadFileChunked, createAsset, updateAsset } from './clientService';
import { getText } from '../i18n';

export const submitNewAsset = async ({
    file,
    newAsset,
    hasExistingUrl,
    uploadOptions,
}) => {
    const assetPayload = { ...newAsset };

    if (!hasExistingUrl) {
        const response = await uploadFileChunked(file, uploadOptions);
        if (response.error) {
            throw new Error(response.message);
        }
        try {
            new URL(response.data);
        } catch {
            throw new Error(getText('msg_3e298875de25'));
        }
        assetPayload.url = response.data;
    }

    const createResponse = await createAsset(assetPayload, null);
    if (createResponse?.error) {
        throw new Error(createResponse.message);
    }
    if (createResponse?.status !== 200) {
        throw new Error(getText('msg_9f8fd8f97fd3'));
    }
    return createResponse;
};

export const submitAssetUpdate = async ({
    replacementFile,
    formattedAsset,
    uploadOptions,
}) => {
    const assetPayload = { ...formattedAsset };

    if (replacementFile) {
        const response = await uploadFileChunked(replacementFile, uploadOptions);
        if (response.error) {
            throw new Error(response.message);
        }
        try {
            new URL(response.data);
        } catch {
            throw new Error(getText('msg_b1da8b169c52'));
        }
        assetPayload.url = response.data;
    }

    const updateResponse = await updateAsset(assetPayload, null);
    if (updateResponse.error) {
        throw new Error(
            updateResponse.message ||
                updateResponse.title ||
                'There was an error updating the asset.',
        );
    }
    if (updateResponse.status !== 200) {
        throw new Error(getText('msg_593b58d0178b'));
    }
    return updateResponse;
};
